import actions from "./actions"
import applet from "./applet"
import errors from "./errors"
import services from "./services"
import triggers from "./triggers"
import queries from "./queries"

const reducers = {
  actions,
  applet,
  errors,
  services,
  triggers,
  queries,
}

export default reducers
